export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    tags: ["科幻", "冒险", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20spaceship%20in%20deep%20space%2C%20epic%20cinematic%20composition%2C%20warm%20orange%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20movie%20poster%20style%20with%20clean%20background&width=600&height=800&seq=movie-cover-01&orientation=portrait",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，一群勇敢的年轻人挺身而出，为了人类的未来而战斗。本片延续前作的宏大世界观，以更加震撼的视觉效果呈现人类在绝境中的勇气与希望。",
    highlights: ["IMAX 3D 视觉效果震撼", "刘德华倾情出演", "国产科幻巅峰之作"],
    updateDate: "2026-08-10",
    featured: true,
  },
  {
    id: 2,
    title: "封神第二部",
    category: "movie",
    tags: ["奇幻", "神话", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20featuring%20ancient%20warriors%20in%20armor%20with%20mythical%20beasts%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20lighting%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-02&orientation=portrait",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    description: "封神大战进入白热化阶段，姜子牙率领众神与纣王的军队展开最终对决。古老的神话传说在银幕上重现，东方奇幻美学与好莱坞级特效完美融合。",
    highlights: ["黄渤、费翔领衔豪华阵容", "东方奇幻视觉盛宴", "票房突破30亿"],
    updateDate: "2026-08-08",
    featured: true,
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    category: "anime",
    tags: ["动画", "神话", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20a%20mischievous%20young%20boy%20character%20with%20fire%20elements%2C%20vibrant%20red%20and%20gold%20colors%2C%20mythological%20Chinese%20style%2C%20dynamic%20action%20pose%2C%20clean%20gradient%20background&width=600&height=800&seq=movie-cover-03&orientation=portrait",
    rating: 9.1,
    year: 2025,
    region: "中国大陆",
    description: "哪吒与敖丙在天劫之后灵魂得以保存，但肉身面临消散的危险。太乙真人打算用七色宝莲为二人重塑肉身，然而过程中却遇到了重重困难和挑战。",
    highlights: ["票房突破50亿", "国产动画新标杆", "全年龄段观影体验"],
    updateDate: "2026-08-05",
    featured: true,
  },
  {
    id: 4,
    title: "庆余年第二季",
    category: "tv",
    tags: ["古装", "权谋", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20a%20scholar%20in%20traditional%20robes%2C%20ancient%20Chinese%20palace%20background%2C%20elegant%20composition%2C%20warm%20golden%20and%20brown%20tones%2C%20cinematic%20portrait%20style&width=600&height=800&seq=movie-cover-04&orientation=portrait",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    description: "范闲从北齐归来后，发现自己卷入了更加复杂的权力斗争之中。京城暗流涌动，各方势力蠢蠢欲动，范闲将如何在波谲云诡的局势中保护身边的亲人？",
    highlights: ["原班人马回归", "剧情更加扣人心弦", "服化道全面升级"],
    updateDate: "2026-08-11",
    featured: true,
  },
  {
    id: 5,
    title: "奥本海默",
    category: "movie",
    tags: ["传记", "历史", "海外"],
    cover: "https://readdy.ai/api/search-image?query=Hollywood%20biographical%20drama%20movie%20poster%20with%20a%20scientist%20silhouette%20against%20a%20mushroom%20cloud%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20dramatic%20cinematic%20composition%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-05&orientation=portrait",
    rating: 8.8,
    year: 2023,
    region: "美国",
    description: "克里斯托弗·诺兰执导的史诗级传记片，讲述了理论物理学家罗伯特·奥本海默领导曼哈顿计划开发原子弹的故事。影片深入探讨了科学、道德与权力之间复杂的关系。",
    highlights: ["诺兰导演新作", "奥斯卡多项获奖", "IMAX胶片拍摄"],
    updateDate: "2026-08-01",
    featured: false,
  },
  {
    id: 6,
    title: "长安三万里",
    category: "anime",
    tags: ["动画", "历史", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20cityscape%20and%20poets%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20warm%20earth%20tones%2C%20elegant%20artistic%20composition%2C%20clean%20parchment%20background&width=600&height=800&seq=movie-cover-06&orientation=portrait",
    rating: 8.5,
    year: 2023,
    region: "中国大陆",
    description: "安史之乱爆发后数年，吐蕃大军攻打西南。困守孤城的高适回忆起了自己与李白跨越数十年的友谊，展现了盛唐诗人波澜壮阔的人生画卷。",
    highlights: ["追光动画十年力作", "盛唐诗人全景呈现", "水墨美学极致"],
    updateDate: "2026-07-28",
    featured: false,
  },
  {
    id: 7,
    title: "狂飙",
    category: "tv",
    tags: ["犯罪", "悬疑", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20two%20men%20facing%20each%20other%2C%20police%20and%20underworld%20theme%2C%20dark%20moody%20atmosphere%2C%20urban%20night%20setting%2C%20cinematic%20noir%20style%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-07&orientation=portrait",
    rating: 9.3,
    year: 2023,
    region: "中国大陆",
    description: "一部横跨二十年的扫黑除恶题材电视剧。以一线刑警安欣和黑恶势力高启强长达二十年的正邪较量为主线，展现了扫黑除恶斗争的艰巨与复杂。",
    highlights: ["现象级爆款剧集", "张译张颂文演技封神", "豆瓣9.3高分"],
    updateDate: "2026-08-09",
    featured: true,
  },
  {
    id: 8,
    title: "蜘蛛侠：纵横宇宙",
    category: "anime",
    tags: ["动画", "超级英雄", "海外"],
    cover: "https://readdy.ai/api/search-image?query=Spider-Man%20animated%20movie%20poster%20with%20multiple%20spider-people%20in%20dynamic%20poses%2C%20vibrant%20comic%20book%20art%20style%2C%20colorful%20graffiti%20aesthetic%2C%20neon%20accents%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-08&orientation=portrait",
    rating: 8.7,
    year: 2023,
    region: "美国",
    description: "迈尔斯·莫拉莱斯踏上跨越多元宇宙的全新冒险旅程，与蜘蛛侠联盟一起对抗强大的新威胁。突破性的视觉风格让每一帧都像一幅精美的漫画艺术作品。",
    highlights: ["奥斯卡最佳动画", "视觉风格革命", "多元宇宙精彩纷呈"],
    updateDate: "2026-07-25",
    featured: false,
  },
  {
    id: 9,
    title: "三体",
    category: "tv",
    tags: ["科幻", "悬疑", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20scenery%20and%20three%20suns%20in%20space%2C%20mysterious%20atmosphere%2C%20deep%20blue%20and%20purple%20cosmic%20colors%2C%20cinematic%20sci-fi%20aesthetic%2C%20clean%20starfield%20background&width=600&height=800&seq=movie-cover-09&orientation=portrait",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    description: "根据刘慈欣同名科幻小说改编。纳米科学家汪淼被卷入一场跨越星际的文明博弈，人类文明面临着来自三体世界的巨大威胁。一场跨越光年的文明对话即将展开。",
    highlights: ["刘慈欣原著改编", "顶级特效团队打造", "国产科幻剧集标杆"],
    updateDate: "2026-08-12",
    featured: true,
  },
  {
    id: 10,
    title: "满江红",
    category: "movie",
    tags: ["悬疑", "历史", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20set%20in%20ancient%20China%20with%20soldiers%20in%20a%20courtyard%2C%20dark%20red%20and%20black%20color%20scheme%2C%20suspenseful%20atmosphere%2C%20lantern%20lighting%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-10&orientation=portrait",
    rating: 8.1,
    year: 2023,
    region: "中国大陆",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场惊天阴谋之中。",
    highlights: ["张艺谋导演新作", "沈腾易烊千玺主演", "悬疑反转不断"],
    updateDate: "2026-07-20",
    featured: false,
  },
  {
    id: 11,
    title: "鬼灭之刃：无限城篇",
    category: "anime",
    tags: ["动画", "热血", "日漫"],
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20demon%20slayer%20characters%20wielding%20swords%2C%20dynamic%20action%20scene%2C%20vibrant%20fire%20and%20water%20effects%2C%20traditional%20Japanese%20art%20style%2C%20clean%20gradient%20background&width=600&height=800&seq=movie-cover-11&orientation=portrait",
    rating: 9.0,
    year: 2026,
    region: "日本",
    description: "炭治郎一行人终于来到鬼舞辻无惨的据点——无限城。在这里，鬼杀队与上弦之鬼展开最终决战，每一位柱都将面临生死考验。热血与泪水交织的终极篇章正式开启。",
    highlights: ["全球票房破纪录", "战斗场面巅峰之作", "ufotable制作"],
    updateDate: "2026-08-06",
    featured: true,
  },
  {
    id: 12,
    title: "繁花",
    category: "tv",
    tags: ["都市", "年代", "国产"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20businessman%20in%20suit%2C%20neon%20city%20lights%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20dark%20background&width=600&height=800&seq=movie-cover-12&orientation=portrait",
    rating: 8.8,
    year: 2024,
    region: "中国大陆",
    description: "九十年代的上海，人人争上游。阿宝凭借改革开放的春风和自己的打拼，成为商界冉冉升起的新星。黄河路上，机遇与挑战并存，商海沉浮间尽显人生百态。",
    highlights: ["王家卫首部电视剧", "胡歌领衔主演", "上海故事细腻呈现"],
    updateDate: "2026-08-03",
    featured: false,
  },
];

export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "anime", name: "动漫", icon: "ri-emotion-line" },
  { slug: "variety", name: "综艺", icon: "ri-live-line" },
];

export const reviews = [
  {
    id: 1,
    user: "影迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish",
    rating: 5,
    content: "片源更新速度超快，画质也特别清晰，已经成为我每日必刷的网站了！推荐给了很多朋友，大家都说好用。",
    date: "2026-08-10",
  },
  {
    id: 2,
    user: "电影发烧友",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20man%20portrait%20avatar%2C%20glasses%2C%20intellectual%20look%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish",
    rating: 5,
    content: "分类很清晰，找片子特别方便。动漫资源也很全，孩子喜欢的动画片这里都能找到，全家人都爱用。",
    date: "2026-08-08",
  },
  {
    id: 3,
    user: "追剧小仙女",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish",
    rating: 5,
    content: "追剧党的福音！更新非常及时，热门剧集当天就能看到。界面也很清爽，没有乱七八糟的广告，体验特别好。",
    date: "2026-08-05",
  },
  {
    id: 4,
    user: "老张看电影",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20older%20man%20portrait%20avatar%2C%20kind%20expression%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish",
    rating: 4,
    content: "退休后每天在家看电影，屁屁影院的资源很丰富，老片新片都有。操作简单，我们老年人也能轻松上手。",
    date: "2026-07-30",
  },
  {
    id: 5,
    user: "二次元控",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20teenager%20portrait%20avatar%2C%20stylish%20look%2C%20bright%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-05&orientation=squarish",
    rating: 5,
    content: "动漫资源太全了！新番更新快，经典老番也有收录。画质高清，而且是原声中字，二次元爱好者狂喜！",
    date: "2026-08-01",
  },
];

export const faqData = [
  {
    question: "屁屁影院是否需要注册才能观看？",
    answer: "不需要。屁屁影院所有影视资源均可免费在线观看，无需注册或登录，打开网站即可享受高清观影体验。我们致力于为用户提供最便捷的观影服务。",
  },
  {
    question: "影片的画质如何？是否支持高清播放？",
    answer: "屁屁影院所有影片均提供1080P高清画质，部分热门影片更支持4K超清画质。您可以根据网络状况自由切换清晰度，确保流畅的观影体验。",
  },
  {
    question: "影片更新频率是怎样的？",
    answer: "我们拥有专业的资源更新团队，热门电影和电视剧通常在上线后24小时内更新。动漫新番每周同步日本播出进度，确保您第一时间观看到最新内容。",
  },
  {
    question: "是否支持手机和平板观看？",
    answer: "屁屁影院采用响应式设计，完美适配手机、平板、电脑等各种设备。您可以在任何设备上获得流畅舒适的观影体验，随时随地想看就看。",
  },
  {
    question: "如何找到我想看的影片？",
    answer: "您可以通过首页的分类导航按电影、电视剧、动漫、综艺等类别浏览，也可以使用搜索功能直接输入影片名称查找。我们还提供了热门推荐和最新更新版块，帮助您发现精彩内容。",
  },
  {
    question: "观看影片时卡顿怎么办？",
    answer: "如果遇到卡顿情况，建议您尝试以下方法：1）切换较低的清晰度；2）检查网络连接状态；3）刷新页面重新加载。如问题持续，请联系我们的客服获取帮助。",
  },
];

export const aboutInfo = {
  brandName: "屁屁影院",
  brandIntro: "屁屁影院成立于2023年，是一个专注于高清影视资源分享的在线平台。我们汇聚全球热门电影、电视剧、动漫及综艺资源，致力于为广大影迷提供优质的在线观影体验。",
  mission: "让每一个人都能自由、便捷地享受高品质影视内容，是我们的初心和使命。",
  stats: [
    { label: "影视资源", value: "10,000+" },
    { label: "日活用户", value: "500万+" },
    { label: "高清画质", value: "1080P+" },
    { label: "更新速度", value: "24h内" },
  ],
  contact: {
    email: "service@pipicinema.com",
    wechat: "pipicinema2023",
    qq: "1234567890",
    address: "中国北京市朝阳区影视产业园区A座",
    phone: "400-888-6666",
    workTime: "周一至周日 9:00 - 21:00",
  },
};